module.exports = __webpack_public_path__ + "static/img/logo-menu.5a964ed.svg";